import React from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
// import { loadLessons, deleteLesson, removeFavoriteLesson } from '../../common/lessons/actions'
import { UsersList } from '../components'

class FollowersPage extends React.Component {
  render() {
    const { intl, viewer } = this.props
    // if (!this.props.users) {
    //   return <span>Loading...</span>
    // }
    const users = viewer.followers
    return (
      <div>
        <h2>{intl.formatMessage(messages.title)}:</h2>
        <UsersList users={users} />
      </div>
    )
  }
}

// FollowersPage.defaultProps = {
//   users: null,
// }

FollowersPage.propTypes = {
  viewer: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    lessons: state.lessons.all,
  }), { }),
  injectIntl,
)

export default enhance(FollowersPage)

const messages = defineMessages({
  title: {
    id: 'followers.page.title',
    defaultMessage: 'Followers',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/FollowersPage.js